import { Component, Input } from '@angular/core';
import { ScenarioTrailItem } from '../../models/sell.models';

@Component({
  selector: 'pla-plate-x-scenario-card',
  templateUrl: './plate-x-scenario-card.component.html',
  styleUrls: ['./plate-x-scenario-card.component.scss'],
})
export class PlateXScenarioCardComponent {
  @Input() registration: string = '';
  @Input() meta: string = '';
  @Input() body: string = '';
  @Input() trail: ScenarioTrailItem[] = [];
}
